// Styles
import styles from './ActionsTable.module.css';

export const ActionsTable = ({children}) => {
  return(
    <section className={styles.container}>
      {children}
    </section>
  );
}